// @flow
import { connect } from 'react-redux';
import { getHubDate } from '~/core/state/hub/selectors';
import TimeAxis from './component';

const mapStateToProps = (state, ownProps): { currentTime: number } => {
    const hubDate = getHubDate(state);

    return {
        currentTime: hubDate.hours() * 60 + hubDate.minutes()
    };
};

export default connect(mapStateToProps)(TimeAxis);



// WEBPACK FOOTER //
// ./src/components/widgets/schedule/time-axis/index.js